export function META() {
    return {
        title: 'Брестчина туристическая',
        description: 'Брестчина туристическая',
        author: '',
        robots: 'index, follow',
        viewport: 'width=device-width, initial-scale=1',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Брест,область,туризм'
            }
        }
    }
}

export function MetaTitleDesc(title, desc)
{
    let result = META();
    result.title = title + ". " + result.title;
    result.description = desc + ". " + result.description;
    return result;
}